import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import { Route, withRouter } from 'react-router-dom'

import Scroll from '@components/Scroll'
import Badge from '@components/Details/Badge'
import Tabs from '@components/Tabs'
import Spinner from '@components/spinner'

import OfficeStore from './office.store'

import DetailsTab from './DetailsTab'
import ProjectsTab from './ProjectsTab'
import CopyButton from '../../components/CopyButton'

class OfficePage extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired,
    history: PropTypes.object,
    growlStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      officeStore: new OfficeStore(props.growlStore)
    })

    const officeId = props.match.params.id

    this.officeStore.load(officeId)
  }

  renderLoader () {
    return <Spinner />
  }

  render () {
    const { history, match } = this.props

    const {
      loading,
      office,
      projectCount,
      projectFeedbackAvg
    } = this.officeStore
    if (loading) {
      return this.renderLoader()
    }

    const tabs = [{ tab: 'details' }, { tab: 'projects' }, { tab: 'logs' }]

    const urlMatch = match.url.match(/search/)
    const isLinkToFullPage = urlMatch && urlMatch.length > 0

    return (
      office && (
        <Scroll>
          <div className='project-wrapper'>
            <div className='details-header'>
              <div className='info info--noLeft'>
                <div>
                  <div className='name-status-wrapper office'>
                    <h1
                      className={isLinkToFullPage ? 'title-link' : ''}
                      onClick={() =>
                        isLinkToFullPage && history.push(`/office/${office.id}`)
                      }
                    >
                      {office.officeName}
                    </h1>
                    <CopyButton value={office.officeName} />
                  </div>
                  <span className='code-label'>
                    {office.account.companyName} |{' '}
                    {office.parentAccount.parentAccountCode}
                  </span>
                </div>
              </div>
              <Badge label='Projects' value={projectCount.projectsCount} />
              <Badge
                label='Feedback'
                value={projectFeedbackAvg}
                onClick={this.showClientFeedbacks}
                hasStar={!!projectFeedbackAvg}
              />
            </div>
            <div className='expert-tabs'>
              <Tabs ignoreExactMatches={['invoicing']} tabs={tabs} />
            </div>
            <div className='views-wrapper'>
              <Route
                exact
                path={match.url}
                render={props => (
                  <DetailsTab {...props} officeStore={this.officeStore} />
                )}
              />
              <Route
                exact
                path={match.url + '/projects'}
                render={props => <ProjectsTab {...props} office={office} />}
              />
            </div>
          </div>
        </Scroll>
      )
    )
  }
}

export default withRouter(inject('growlStore')(observer(OfficePage)))
